import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function evaluateCriteria(params: { activityId: number; expression: string; userId?: number; atTime?: string }) {
    const { activityId, expression = '', userId, atTime } = params;

    if (expression == null || expression === '') {
        return true;
    }

    const queryParams = [
        `activity_id=${activityId}`,
        `expression=${expression}`,
        ...(userId ? [`user_id=${userId}`] : []),
        ...(atTime ? [`at_time=${atTime}`] : []),
    ];

    try {
        const { status, data } = await axios.get<{ result: boolean }>(
            `${Endpoints.Activity.CriteriaEvaluation}/?${queryParams.join('&')}`
        );

        if (status === 200) {
            return data.result;
        } else {
            return false;
        }
    } catch {
        return false;
    }
}
